import { type CountryCode, countryCodeMap } from '@constants'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'

const styles = stylex.create({
  info: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
  },
})

interface ShippingInfoProps {
  shippingAddress?: string
  shippingPhone?: string
  shippingName?: string
  rootStyle?: stylex.StyleXStyles
  shippingMethodTitle?: string
  countryCode?: CountryCode
  cvsStoreName?: string | null
  cvsStoreLabel?: string
  postalCode?: string
}

export const ShippingInfo = ({ shippingAddress, shippingPhone, shippingName, rootStyle, shippingMethodTitle, countryCode, cvsStoreName, cvsStoreLabel, postalCode }: ShippingInfoProps) => {
  const { t } = useTranslation()
  return (
    <VStack rootStyle={rootStyle}>
      <Text variant="subtitle">{t('orderDetail.shippingInfo', { defaultValue: '配送資訊' })}</Text>
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>{t('orderDetail.shippingRules', { defaultValue: '配送方式' })}</Text>
        <Text>{shippingMethodTitle}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>{t('orderDetail.shippingRecipient', { defaultValue: '收件人' })}</Text>
        <Text>{shippingName}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>{t('orderDetail.shippingRegion', { defaultValue: '配送地區' })}</Text>
        <Text>{countryCode ? t(`orderDetail.${countryCode}`, { defaultValue: countryCodeMap[countryCode] }) : '-'}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>{t('orderDetail.postalCode', { defaultValue: '郵遞區號' })}</Text>
        <Text>{postalCode || '-'}</Text>
      </Box>
      {cvsStoreName
      && (
        <Box rootStyle={styles.info}>
          <Text color={colors.grey600}>{cvsStoreLabel ?? t('orderDetail.pickupStore', { defaultValue: '配送門市' })}</Text>
          <Text>{cvsStoreName}</Text>
        </Box>
      )}
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>{t('orderDetail.shippingAddress', { defaultValue: '配送地址' })}</Text>
        <Text>{shippingAddress}</Text>
      </Box>
      <Box rootStyle={styles.info}>
        <Text color={colors.grey600}>{t('orderDetail.shippingPhone', { defaultValue: '聯絡電話' })}</Text>
        <Text>{shippingPhone}</Text>
      </Box>
    </VStack>
  )
}
